import type React from 'react';

import { useSelector } from 'react-redux';

import { selectFacecoverVersion } from '@vlapps/point/src/app/store/selectors';

import { BagDetails } from './analytics/BagDetails';
import { CrowdDetails } from './analytics/CrowdDetails';
import { FacecoverDetailsSelect } from './analytics/facecover/FacecoverDetailsSelect';
import { FallDetails } from './analytics/FallDetails';
import { FightDetails } from './analytics/FightDetails';
import { FireDetails } from './analytics/FireDetails';
import { HandsupDetails } from './analytics/HandsupDetails';
import { LyingDetails } from './analytics/LyingDetails';
import { WeaponDetails } from './analytics/WeaponDetails';
import type { AnalyticDetailsEvent } from './types';

interface VideoAnalyticsDetailsProps {
  event: AnalyticDetailsEvent;
}

export function VideoAnalyticsDetails({
  event,
}: VideoAnalyticsDetailsProps): React.JSX.Element | null {
  const facecoverVersion = useSelector(selectFacecoverVersion);
  if (!event) return null;

  switch (event.event_type) {
    case 'bag':
      return <BagDetails event={event} />;
    case 'crowd':
      return <CrowdDetails event={event} />;
    case 'facecover':
    case 'balaclava':
    case 'niqab':
    case 'other':
      return (
        <FacecoverDetailsSelect
          event={event}
          version={facecoverVersion}
        />
      );
    case 'fall':
      return <FallDetails event={event} />;
    case 'fight':
      return <FightDetails event={event} />;
    case 'fire':
      return <FireDetails event={event} />;
    case 'handsup':
      return <HandsupDetails event={event} />;
    case 'lying':
      return <LyingDetails event={event} />;
    case 'weapon':
      return <WeaponDetails event={event} />;
    default:
      break;
  }

  return null;
}
